import { render, staticRenderFns } from "./SizeBox.vue?vue&type=template&id=7979307c&"
import script from "./SizeBox.vue?vue&type=script&lang=js&"
export * from "./SizeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports